import React from 'react'
import Anime from 'react-anime'
import styled from 'styled-components'
import Arrow from 'react-icons/lib/md/keyboard-arrow-right'

import Button from './button'
import Input from './input'

const Label = styled.label`
  margin-bottom: 5px;
  font-weight: 500;
  color: ${props => props.theme.color};
`

const Circle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-block;
  background: ${props => props.theme.color};
`

const FadedLink = styled.a`
  opacity: 0.3;
  font-size: 0.8em;
  text-align: right;
  text-decoration: underline;
  color: black;
  :hover {
    opacity: 0.9;
    color: ${props => props.theme.color};
  }
`
const Center = styled.div`
  text-align: center;
`

const Slide = styled.div`
  position: absolute;
  opacity: 1;
  transform: translateX(0px) scale(1);
  transition: all 0.4s ease-in-out;
  z-index: 50;
  ${({slide, currentSlide}) => {
    if (slide > currentSlide) {
      return `
      transform: translateX(80px) scale(1.1);
      opacity: 0;
      z-index: 0;
      user-select: none;
      `
    } else if (slide < currentSlide) {
      return `
      transform: translateX(-100px) scale(0.8);
      opacity: 0;
      z-index: 0;
      user-select: none;
      `
    }
  }};
`

const Wrapper = styled.div`
  margin: 100px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Form = styled.form`
  display: flex;
  margin-bottom: 5px;
  flex-direction: column;
`

class Dienstplan extends React.Component {
  state = {
    slide: 0,
    dienstnummer: '',
    token: ''
  }

  handleDienstnummerChange = e => {
    let dienstnummer = e.target.value.match(/\d+/)
    dienstnummer = dienstnummer && dienstnummer[0]
    this.setState({
      dienstnummer: dienstnummer
    })
  }
  handleTokenChange = e => {
    this.setState({
      token: e.target.value
    })
  }
  submitTo = n => {
    return e => {
      e.preventDefault()
      this.setState(({slide}) => ({
        slide: n
      }))
    }
  }
  to = n => {
    return () => {
      this.setState(({slide}) => ({
        slide: n
      }))
    }
  }
  async getUrl(dienstnummer, token) {
    console.log(
      `https://dienst.kreuz.co/activate?userId=${dienstnummer}&token=${token}`
    )
    const response = await fetch(
      `https://dienst.kreuz.co/activate?userId=${dienstnummer}&token=${token}`
    )
    const {ics} = await response.json()

    return ics
  }
  submit = async e => {
    e.preventDefault()
    const {token, dienstnummer} = this.state
    this.setState({
      slide: 3
    })
    const url = await this.getUrl(dienstnummer, token)
    this.setState({
      slide: 4,
      url
    })
  }
  render() {
    return (
      <Wrapper>
        <Slide onClick={this.to(1)} slide={0} currentSlide={this.state.slide}>
          <Button>
            Synchronisieren <Arrow size={24} />
          </Button>
        </Slide>
        <Slide slide={1} currentSlide={this.state.slide}>
          <Form onSubmit={this.submitTo(2)}>
            <Label>Deine Dienstnummer</Label>
            <Input
              innerRef={input =>
                input && this.state.slide === 1 && input.focus()
              }
              onChange={this.handleDienstnummerChange}
              value={this.state.dienstnummer}
              placeholder="123456"
              type="text"
            />
          </Form>
        </Slide>
        <Slide slide={2} currentSlide={this.state.slide}>
          <Form onSubmit={this.submit}>
            <Label>Dein Token</Label>
            <Input
              innerRef={input =>
                input && this.state.slide === 2 && input.focus()
              }
              onChange={this.handleTokenChange}
              value={this.state.token}
              placeholder="a1b2c3"
              type="text"
            />
          </Form>
          <Center>
            <FadedLink
              target="_blank"
              href="https://portal.n.roteskreuz.at/y/mobileapp/token"
            >
              Noch keinen Token?
            </FadedLink>
          </Center>
        </Slide>
        <Slide slide={3} currentSlide={this.state.slide}>
          <Anime
            loop
            delay={(e, i) => i * 40}
            direction="alternate"
            scale={[0.3, 0.8]}
            opacity={[0, 1]}
          >
            <div>
              <Circle />
            </div>
          </Anime>
        </Slide>
        <Slide slide={4} currentSlide={this.state.slide}>
          {this.state.url}
        </Slide>
      </Wrapper>
    )
  }
}

export default Dienstplan



// WEBPACK FOOTER //
// ./src/components/dienstplan.js